import { ThemeInput } from '../types'

// Blood Moon theme - based on Spooky font pairing (Nosifer + Lora)
export const BLOOD_MOON_THEME: ThemeInput = {
  name: 'Blood Moon',
  description: 'Dark, dramatic theme with horror-style typography and deep red accents',

  // Typography - from Spooky font pairing
  displayFont: 'Nosifer',
  bodyFont: 'Lora',
  displayWeight: 'normal', // Nosifer looks best at normal weight
  bodyWeight: 'normal',

  // Dark Mode Colors (Primary use)
  darkMode: {
    primary: '#9f1239',     // rose-800 - Deep blood red
    secondary: '#5b21b6',   // violet-800 - Dark purple accent
    accent: '#f59e0b',      // amber-500 - Warm moonlight highlight
    background: '#0f0f0f',  // Near-black
    surface: '#1a1a1a',     // Dark card backgrounds
    text: '#f1f5f9',        // slate-100 - Light text on dark
    textMuted: '#94a3b8',   // slate-400 - Muted secondary text
  },

  // Light Mode Colors
  lightMode: {
    primary: '#be123c',     // rose-700 - Vivid blood red
    secondary: '#7c3aed',   // violet-600 - Purple accent
    accent: '#d97706',      // amber-600 - Warm highlight
    background: '#fafaf9',  // stone-50 - Warm off-white
    surface: '#ffffff',     // White cards
    text: '#1c1917',        // stone-900 - Dark text
    textMuted: '#57534e',   // stone-600 - Muted text
  },

  // Style
  borderRadius: 'sm',  // Sharp, gothic feel
  shadow: 'lg',        // Dramatic depth
}

// Additional default themes can be added here
export const DEFAULT_THEMES: ThemeInput[] = [
  BLOOD_MOON_THEME,
]
